import ApplicationAdapter from 'uplisting-frontend/adapters/application';

export default class TeamMessageAdapter extends ApplicationAdapter {
  remove(id: string): Promise<void> {
    return this.ajax(
      this.buildURL('team-message', id),
      'DELETE',
    ) as Promise<void>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'team-message': TeamMessageAdapter;
  }
}
